<!--suppress XmlDuplicatedId -->
@if (hasKnowledgeOrBehaviouralIndicator()) {
  <div
    >
    <div
      [ngClass]="'c-accordion ' + (competenceSelected ? '-is-open' : '-is-closed')">
      <div id="occupational-profile-competence-item-{{index}}" class="c-accordion__header" (click)="clickAccordionHeader(competence, $event)">
        <h3 class="mb0">
          <button class="c-accordion__button" aria-expanded="false">
            {{competence.skill.description.nl}}
          </button>
        </h3>
        <a [ngClass]="'c-accordion__toggle-btn ' + (competenceSelected ? 'action-hide' : 'action-show')"></a>
      </div>
      <div class="c-accordion__content" aria-hidden="true">
        <div class="c-skills__content">
          @if (competence.behaviouralIndicators?.length > 0) {
            <div class="c-skills__subcategory"
              >
              <h4 id="occupational-profile-competence-behavioural-indicator-{{index}}" class="c-skills__subcategory-title">Gedragsindicatoren</h4>
              <ul>
                @for (behaviouralIndicator of competence.behaviouralIndicators; track behaviouralIndicator) {
                  <li>
                    {{behaviouralIndicator.description.nl}}
                  </li>
                }
              </ul>
            </div>
          }
          @if (competence.knowledgeItems?.length > 0) {
            <div class="c-skills__subcategory"
              >
              <h4 id="occupational-profile-competence-knowledge-{{index}}" class="c-skills__subcategory-title">Kennis</h4>
              <ul>
                @for (knowledge of competence.knowledgeItems; track knowledge) {
                  <li>
                    {{knowledge.description.nl}}
                  </li>
                }
              </ul>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}
@if (!hasKnowledgeOrBehaviouralIndicator()) {
  <div
    >
    <div id="occupational-profile-competence-item-{{index}}" class="c-skills__non-accordion-item">
      <h3 class="h5 mb0">
        {{competence.skill.description.nl}}
      </h3>
    </div>
  </div>
}

